import { ProfileData } from '../types/profileTypes';

export const validateFormData = (data: ProfileData): string[] => {
  const errors: string[] = [];
  
  // Validate numeric fields
  if (data.age !== null && (data.age < 1 || data.age > 120)) {
    errors.push('Age must be between 1 and 120');
  }
  if (data.height_cm !== null && (data.height_cm < 50 || data.height_cm > 300)) {
    errors.push('Height must be between 50 and 300 cm');
  }
  if (data.current_weight_kg !== null && (data.current_weight_kg < 20 || data.current_weight_kg > 500)) {
    errors.push('Current weight must be between 20 and 500 kg');
  }
  if (data.weight_goal_kg !== null && (data.weight_goal_kg < 20 || data.weight_goal_kg > 500)) {
    errors.push('Goal weight must be between 20 and 500 kg');
  }
  
  return errors;
};